import React from 'react';

import { Box, Typography } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import cpdLogo from '../../../../assets/images/cpd-logo.png';
import useStyles from './styles';

interface CpdCreditsProps {
  cpdCredits?: string | null;
  wrapperClass?: string;
}

const CpdCredits: React.FC<CpdCreditsProps> = ({ cpdCredits, wrapperClass }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={cx(classes.wrapper, wrapperClass)}>
      <img src={cpdLogo} alt="cpd credits" className={classes.image} />
      <Typography className={classes.text}>
        {cpdCredits} {t('common.cpdCredits')}
      </Typography>
    </Box>
  );
};

export default CpdCredits;
